export default function BasicSpecs() {
  const specs = [
    { label: '年会費', value: '永年無料' },
    { label: '基本還元率', value: '1.2%' },
    { label: '国際ブランド', value: 'Visa / Mastercard / JCB' },
    { label: 'ポイント名', value: '独自ポイント' },
    { label: 'ポイント有効期限', value: '最終利用日から1年間' },
    { label: '申込資格', value: '18歳以上（高校生を除く）' },
    { label: '発行スピード', value: '最短1週間' },
    { label: '電子マネー', value: '楽天Edy / モバイルSuica / SMART ICOCA' },
    { label: 'スマホ決済', value: 'Apple Pay / Google Pay' },
    { label: '家族カード', value: '無料' },
    { label: 'ETCカード', value: '無料（JCBのみ）※Visa/Mastercardは発行手数料1,100円' },
    { label: '海外旅行保険', value: '最高2,000万円（利用付帯）' },
    { label: '国内旅行保険', value: '最高1,000万円（利用付帯）' },
    { label: 'ショッピング保険', value: '年間200万円' }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-4xl mx-auto px-4">
        <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
          基本スペック
        </h2>
        <div className="bg-gradient-to-br from-gray-50 to-white rounded-2xl shadow-lg overflow-hidden border border-gray-100">
          <div className="divide-y divide-gray-200">
            {specs.map((spec, index) => (
              <div
                key={index}
                className="grid grid-cols-1 md:grid-cols-2 hover:bg-orange-50 transition-colors duration-200"
              >
                <div className="px-6 py-4 bg-gray-50 font-semibold text-gray-700 flex items-center">
                  <i className="ri-checkbox-circle-line text-orange-500 mr-3 text-xl w-6 h-6 flex items-center justify-center"></i>
                  {spec.label}
                </div>
                <div className="px-6 py-4 text-gray-900 flex items-center">
                  {spec.value}
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="mt-8 text-center">
          <a
            href="https://px.a8.net/svt/ejp?a8mat=4AXB0E+3PYKNU+4T5W+5YRHE"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="inline-block bg-gradient-to-r from-orange-500 to-red-500 text-white font-bold px-8 py-4 rounded-xl hover:from-orange-600 hover:to-red-600 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            公式サイトで詳細を見る
            <i className="ri-arrow-right-line ml-2"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
